//
import { RFormFields } from '@/components/reusable_components/next'
import CustomerModel from '@/models/Sale/SlCustomer'

//
export default new RFormFields(
  {
    name: 'number',
    type: 'text-field',
    props: {
      label: 'Numero',
    },
  },
  {
    name: 'sl_customer_id',
    type: 'autocomplete-model',
    props: {
      itemText: 'business_name',
      itemValue: 'id',
      label: 'Cliente',
      model: CustomerModel,
      noObject: true,
      paramSearch: 'search',
    },
    trigger(ctx) {
      ctx.getField('sl_customer_branch_offices_id').props.items = ctx.getInput('sl_customer_id').getSelected().branch_offices
      ctx.$forceUpdate()
    },
  },
  {
    name: 'sl_customer_branch_offices_id',
    type: 'select',
    props: {
      label: 'Sucursal',
      items: [],
      itemText: 'address',
      itemValue: 'id',
      noObject: true,
    },
  },
)
